const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 15/12/16.
 */
const React = require('react');

const { formatText } = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');
const mockHelper = require('../../../utilities/mockDataHelper');
const formHelper = require('../../../utilities/formHelper');
class AddHolder extends React.Component {

    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                includeAnotherHolder: false,
                name: '',
                lastName: '',
                secondLastName: '',
                documentType: '',
                documentNumber: '',
                relationshipWithTheHolder: '',
                component_id: 'addHolder'
            };
        }
        this.state = initialState;
        this.buildRadioOptions = this.buildRadioOptions.bind(this);
        this.handleOnRadioButtonChange = this.handleOnRadioButtonChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnChangeDocumentType = this.handleOnChangeDocumentType.bind(this);
        this.showForm = this.showForm.bind(this);
    }

    buildRadioOptions() {
        let radioOptions = [];
        mockHelper.mockAddHolder().forEach((option, index) => {
            radioOptions.push(
                <RadioButton
                    key={index}
                    label={option.label}
                    value={formHelper.stringToBoolean(option.value)}
                    className="block-step__radio" />
            );
        });
        return radioOptions;
    }

    handleOnBlur(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleOnChange(event) {
        this.setState({ relationshipWithTheHolder: event.value });
    }

    handleOnChangeDocumentType(event) {
        this.setState({ documentType: event.value });
    }

    handleOnRadioButtonChange(event) {
        this.setState({ includeAnotherHolder: formHelper.stringToBoolean(event) });
    }

    showForm() {
        return this.state.includeAnotherHolder ? (
            <div>
                <div>
                    <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderNameTitle')}</div>
                        <InputSafe
                            label={null}
                            name="name"
                            onBlur={this.handleOnBlur}
                            onChange={null}
                            referenceName="name"
                            type="text"
                            value={this.state.name}
                        />
                    </div>
                    <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderLastName')}</div>
                        <InputSafe
                            label={null}
                            name="lastName"
                            onBlur={this.handleOnBlur}
                            onChange={null}
                            referenceName="lastName"
                            type="text"
                            value={this.state.lastName}
                        />
                    </div>
                    <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderSecondLastName')}</div>
                        <InputSafe
                            label={null}
                            name="secondLastName"
                            onBlur={this.handleOnBlur}
                            onChange={null}
                            referenceName="secondLastName"
                            type="text"
                            value={this.state.secondLastName}
                        />
                    </div>
                </div>
                <div className="laboral-data__input-row">
                    <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderDocumentType')}</div>
                        <OKSelect
                            placeholder="Selecciona"
                            searchable={true}
                            options={mockHelper.mockDocumentType()}
                            onChange={this.handleOnChangeDocumentType}
                            value={this.state.documentType}
                        />
                    </div>
                    <div className="laboral-data__workers-data--first-row laboral-data__form-element">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderDocumentNumber')}</div>
                        <InputSafe
                            label={null}
                            name="documentNumber"
                            onBlur={this.handleOnBlur}
                            onChange={null}
                            referenceName="documentNumber"
                            type="text"
                            value={this.state.documentNumber}
                        />
                    </div>
                </div>
                <div>
                    <div className="laboral-data__form-element laboral-data__two-columns">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountLaboralDataCompanyDataEmploymentRelationshipTitle')}</div>
                        <OKSelect
                            placeholder={formatText('contractsView-checkingAccountAddHolderComboSelect')}
                            searchable={true}
                            options={mockHelper.mockDocumentType()}
                            onChange={this.handleOnChange}
                            value={this.state.relationshipWithTheHolder}
                        />
                    </div>
                </div>
            </div>
        ) : null;
    }

    render() {
        this.props.dataReceiver(this.state);
        return (
            <div className="laboral-data">
                <Accordion customClassName="laboral-data__accordion" isExpanded={true}>
                    <AccordionHeader name="AccordionHeader" isRightArrowPosition={true}>
                        <h4 className="contract-view__subtitle">{formatText('contractsView-checkingAccountAddHolderTitle')}</h4>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div>
                            <div className="laboral-data__add-holder">
                                <div className="ok-slider__text">{formatText('contractsView-checkingAccountAddHolderAnotherHolder')}</div>
                                <RadioButtonGroup
                                    name="addHolder"
                                    idPrefix="addHolderRadio"
                                    selectedValue={this.state.includeAnotherHolder}
                                    className="block-step__radio-group"
                                    onChange={this.handleOnRadioButtonChange}>
                                    {this.buildRadioOptions()}
                                </RadioButtonGroup>
                            </div>
                            {this.showForm()}
                        </div>
                    </AccordionBody>
                </Accordion>
            </div>);
    }
}

AddHolder.propTypes = {
    values: PropTypes.any,
    dataReceiver: PropTypes.func
};

module.exports = AddHolder;
